/*
 * Public API Surface of ng-color-scale
 */

export * from './lib/ng-color-scale.service';
export * from './lib/ng-color-scale.component';
export * from './lib/ng-color-scale.module';
